import React from 'react';
import { InputProps } from './interface';
import './style.scss';

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ label, onChange,  value, error, type, classFlex, 
    disabled, onBlur, maxLength }, ref) => {
    const errorClassName = error ? 'input-error' : '';
    const disabledClassName = disabled ? 'input-disabled' : '';    

    return (
        <label className={`input-container ${classFlex || ''}`}>
            <div className="input-label">{label}</div>
            {type === 'number' ?
                <div className='mb-15'>
                    <input type={type} ref={ref} value={value} min={1} max={50} disabled={disabled} maxLength={maxLength}
                        className={`input ${errorClassName} ${disabledClassName}`} onChange={onChange} onBlur={onBlur} />
                    {/* {error && <div className="error-message">{error}</div>} */}
                </div>
                :
                <div className='mb-15'>
                    <input type={type} ref={ref} value={value} disabled={disabled} onChange={onChange} onBlur={onBlur}
                    maxLength={maxLength} className={`input ${errorClassName} ${disabledClassName}`} />
                    {/* {error && <div className="error-message">{error}</div>} */}
                </div>
            }
        </label>
    )
});